import React from 'react';
export const EmblaCarouselArrowButton = ({ onClick, disabled, icon, ariaLabel }) => {
    return (React.createElement("button", { onClick: onClick, className: `bg-white rounded-full h-[38px] w-[38px] flex items-center justify-center z-10 shadow-lg ${disabled ? 'opacity-50 cursor-not-allowed' : 'opacity-100'}`, disabled: disabled, "aria-label": ariaLabel }, icon));
};
